export const adapters = [
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "105TC",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/105tc.PNG",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "106CN",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/106cn.PNG",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "107 LHN",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/jkl3y0x5.png",
        "Brand": "Pettinaroli",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "107L",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/jkl3u2jc.png",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "107LD - 107LKIT",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/107ld%2C107lkit.PNG",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "107LHC",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/107lhc.PNG",
        "Brand": "Pettinaroli",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "107LHN",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/107lhnm30x15.PNG",
        "Brand": "Pettinaroli",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "107LKIH - 107LKIS",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/107lkih%2C107lkis.PNG",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "107LOD",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/107lod.PNG",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "107LR",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/107lr.PNG",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "108L",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/108l.PNG",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "109L",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/109l.PNG",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "109L Chrome",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/109lcro.PNG",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "130",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/jkl4pr1u.png",
        "Brand": "Pintossi",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "13030000",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/jvz632qo.png",
        "Brand": "Pintossi",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "danfoss_ravl",
        "name": "1610",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/1610.jpg",
        "Brand": "FAR",
        "field6": "",
        "productId": "6647643865155"
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "1820",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/1820.jpg",
        "Brand": "FAR",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "1824",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/jkl30ss2.png",
        "Brand": "FAR",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "1825",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/jkl3as1i.png",
        "Brand": "FAR",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "1828",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/1828.jpg",
        "Brand": "FAR",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "2080",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/2080.jpg",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "320 KD",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/320kd.jpg",
        "Brand": "GAMPPERARMATUREN",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "320 KH...",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/320kh.jpg",
        "Brand": "GAMPPERARMATUREN",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "348811HB",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/348811hb.PNG",
        "Brand": "Alliance",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "7230-7260",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/7230-7260.PNG",
        "Brand": "Herz",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "7235",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/7235.JPG",
        "Brand": "Herz",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "7262",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/7262.PNG",
        "Brand": "Herz",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "8250",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/8250.jpg",
        "Brand": "Herz",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "8251",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/8251.JPG",
        "Brand": "Herz",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "9200-9201",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/9200-9201.jpg",
        "Brand": "Herz",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "9230-9260",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/9230-9260.jpg",
        "Brand": "Herz",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "9553",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/9553.jpg",
        "Brand": "Tiemme",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "9556",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/9556.jpg",
        "Brand": "Tiemme",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "9559",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/9559.jpg",
        "Brand": "Tiemme",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "9860 - 9860H - 9861 - 9861H",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/9860-9860h-9861-9861h.PNG",
        "Brand": "Herz",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "Aduna",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/jkl2ppav.png",
        "Brand": "Orkli",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "Arima-Eroso",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/arima-eroso.jpg",
        "Brand": "Orkli",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "B",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/b.jpg",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "BTRV15LS",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/btrv15ls.jpg",
        "Brand": "Boss",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Brillant Plus Series",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/brillantplusseries.jpg",
        "Brand": "Schlosser",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Brillant Series",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/brillantseries.jpg",
        "Brand": "Schlosser",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "Bull Dog",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/ka6r0dv4.png",
        "Brand": "Pegler",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "C - Diamant Plus Series",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/c-diamantplusseries.jpg",
        "Brand": "Schlosser",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "C - Diamant Series",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/c-diamantseries.jpg",
        "Brand": "Schlosser",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "Caleffi",
        "name": "200",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/caleffi200.jpg",
        "Brand": "Caleffi",
        "field6": "",
        "productId": "6645012070467"
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "201",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/caleffi201.jpg",
        "Brand": "Caleffi",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "Caleffi",
        "name": "202",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/caleffi202.jpg",
        "Brand": "Caleffi",
        "field6": "",
        "productId": "6645012070467"
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "203",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/caleffi203.jpg",
        "Brand": "Caleffi",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "Caleffi",
        "name": "204",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/caleffi204.jpg",
        "Brand": "Caleffi",
        "field6": "",
        "productId": "6645012070467"
    },
    {
        "compatibility": "compatible",
        "adapter": "Caleffi",
        "name": "WICAL 210",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/caleffiwical210.jpg",
        "Brand": "Caleffi",
        "field6": "",
        "productId": "6645012070467"
    },
    {
        "compatibility": "compatible",
        "adapter": "Caleffi",
        "name": "205",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/jj4drrv3.png",
        "Brand": "Caleffi",
        "field6": "",
        "productId": "6645012070467"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Connect - Connect Z",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/connect-connectz.jpg",
        "Brand": "Danfoss",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "D",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/d.jpg",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15/M28x15",
        "name": "D-U",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/d-u.jpg",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "DH 01",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/dh01.jpg",
        "Brand": "IVAR",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "DR - Diamant Plus Series",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/dr-diamantplusseries.jpg",
        "Brand": "Schlosser",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "DR - Diamant Series",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/dr-diamantseries.jpg",
        "Brand": "Schlosser",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "DTW",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/dtw.PNG",
        "Brand": "MMA",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "DX Beige",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/dxbeige.jpg",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "DX Black",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/dxblack.jpg",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "DX Grey",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/dxgrey.jpg",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "DX White",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/dxwhite.jpg",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Deco Chrome",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/jki9n4fw.png",
        "Brand": "JAGA",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "Deco Comap Silver",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/jki9l3rp.png",
        "Brand": "JAGA",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "ECA",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/eca.jpg",
        "Brand": "ValfSanayii",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "Ecocal",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/ecocal.jpg",
        "Brand": "Altecnic",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "Evosense Public",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/evosensepublic.PNG",
        "Brand": "MMA",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "Evosense Sprint",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/evosensesprint.PNG",
        "Brand": "MMA",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "Evosense Standard",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/evosensestandard.PNG",
        "Brand": "MMA",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "F",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/f.jpg",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Fusion",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/fusion.jpg",
        "Brand": "Valvex",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "HT Diamant Plus Series",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/ht-diamantplusseries.jpg",
        "Brand": "Schlosser",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "HT Diamant Series",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/ht-diamantseries.jpg",
        "Brand": "Schlosser",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Harmony",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/harmony.jpg",
        "Brand": "Orkli",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Iris",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/iris.jpg",
        "Brand": "Valvex",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "K",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/k.jpg",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "K old",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/kold.jpg",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "K470H",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/k470h.jpg",
        "Brand": "Giacomini",
        "field6": "",
        "productId": "6645013676099"
    },
    {
        "compatibility": "compatible",
        "adapter": "",
        "name": "Living eco 1",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/livingeco1.jpg",
        "Brand": "Danfoss",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "",
        "name": "Living eco 2",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/livingeco2.PNG",
        "Brand": "Danfoss",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "M28",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/m28.jpg",
        "Brand": "ARCO",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "M28 V1",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/m28v1.jpg",
        "Brand": "ARCO",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "M30 V1",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/m30v1.jpg",
        "Brand": "ARCO",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "MTN51GB TRV",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/jkjdetse.png",
        "Brand": "Siemens",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "MTW AD",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/mtwad.png",
        "Brand": "MMA",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Mini Series",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/miniseries.jpg",
        "Brand": "Schlosser",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "",
        "name": "Model 1",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/model1.png",
        "Brand": "SARCOMAP",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15/M28x15",
        "name": "Model 2",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/model2.png",
        "Brand": "SARCOMAP",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Petite",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/petite.png",
        "Brand": "Myson",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra/ M30x15",
        "name": "Pinox D",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/pinoxd.jpg",
        "Brand": "Oventrop",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Pinox H",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/pinoxh.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "Giacomini",
        "name": "R460",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/r460.jpg",
        "Brand": "Giacomini",
        "field6": "",
        "productId": "6645013676099"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "R460H",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/r460h.jpg",
        "Brand": "Giacomini",
        "field6": "",
        "productId": "6645013676099"
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "R462",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/r462.jpg",
        "Brand": "Giacomini",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "R463",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/r463.jpg",
        "Brand": "Giacomini",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "Giacomini",
        "name": "R468",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/r468.jpg",
        "Brand": "Giacomini",
        "field6": "",
        "productId": "6645013676099"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "R468H",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/r468h.jpg",
        "Brand": "Giacomini",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "Giacomini",
        "name": "R470",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/r470.jpg",
        "Brand": "Giacomini",
        "field6": "",
        "productId": "6645013676099"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "R470H",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/r470h.jpg",
        "Brand": "Giacomini",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RA 2000",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/ra2000.jpg",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RA 2920",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/ra2920.jpg",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RA33S",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/ra33s.jpg",
        "Brand": "BathEmpire",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RAE-K",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/rae-rae-k.jpg",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RAL 9005",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/jki9e8fs.png",
        "Brand": "JAGA",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RAL 9016",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/jki9g86t.png",
        "Brand": "JAGA",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RAS-C2",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/ras-c2.JPG",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RAS-CK",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/ras-ck.jpg",
        "Brand": "Danfoss",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RAS-D2",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/ras-d2.jpg",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RAW",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/raw.jpg",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RAX",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/rax.jpg",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RAX Stainless steel",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/raxstainlesssteel.jpg",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RAX Black",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/raxblack.jpg",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RAX Chrome",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/raxchrome.jpg",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RAX White",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/raxwhite.jpg",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RAX-K Chrome",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/rax-kchrome.PNG",
        "Brand": "Danfoss",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RAX-K White",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/rax-kwhite.PNG",
        "Brand": "Danfoss",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RT 212",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/rt212.jpg",
        "Brand": "Eberle",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RT 411 D",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/rt411d.jpg",
        "Brand": "Eberle",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RT 411 H",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/rt411h.PNG",
        "Brand": "Eberle",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RT 414",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/rt414.jpg",
        "Brand": "Eberle",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RT112",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/rt112.jpg",
        "Brand": "Drayton",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RT212",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/rt212.PNG",
        "Brand": "Drayton",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RT313",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/rt313.PNG",
        "Brand": "Drayton",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RT414",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/rt414.PNG",
        "Brand": "Drayton",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RT56.05",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/jf2ogv7a.png",
        "Brand": "Siemens",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RTN",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/rtn.jpg",
        "Brand": "Siemens",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RTN51",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/rtn51.jpg",
        "Brand": "Siemens",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RTW",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/rtw.PNG",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Radio",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/radio.jpg",
        "Brand": "Blyss",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Rondostat HR20",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/rondostathr20.jpg",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "SH - Diamant Invest",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/sh-diamantinvest.jpg",
        "Brand": "Schlosser",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "SH - Diamant Plus Series",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/sh-diamantplusseries.jpg",
        "Brand": "Schlosser",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "SH - Diamant Series",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/sh-diamantseries.jpg",
        "Brand": "Schlosser",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Sensitive Blanc",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/sensitiveblanc.jpg",
        "Brand": "SARCOMAP",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Sensitive Chrome",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/sensitivechrome.png",
        "Brand": "SARCOMAP",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15/M28x15",
        "name": "Sensity",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/sensity.png",
        "Brand": "SARCOMAP",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "Senso",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/senso.jpg",
        "Brand": "SARCOMAP",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15/M28x15",
        "name": "Senso all color",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/sensoallcolor.jpg",
        "Brand": "SARCOMAP",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15/M28x15",
        "name": "Senso old",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/sensoold.jpg",
        "Brand": "SARCOMAP",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Simple",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/simple.jpg",
        "Brand": "Blyss",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "T 1000",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/t1000.jpg",
        "Brand": "IVAR",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "T 3000",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/t3000.png",
        "Brand": "IVAR",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "T 5000",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/t5000.jpg",
        "Brand": "IVAR",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "T100M",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/t100m.jpg",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "T100V-T100VM",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/t100v-t100vm.jpg",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "TD 3000",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/td3000.png",
        "Brand": "IVAR",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15/M28x15",
        "name": "TRV 2 Way",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/trv2way.jpg",
        "Brand": "Myson",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15/M28x15",
        "name": "TRV 300",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/trv300.jpg",
        "Brand": "Heimeier",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TRV 4 Chrome",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/trv4chrome.jpg",
        "Brand": "Eberle",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TRV 4 Classic",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/trv4classic.jpg",
        "Brand": "Eberle",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TRV1",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/trv1.jpg",
        "Brand": "ECA",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TRV1",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/trv1.jpg",
        "Brand": "ValfSanayii",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TRV2",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/trv2.jpg",
        "Brand": "ECA",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TRV2",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/trv2.jpg",
        "Brand": "ValfSanayii",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "TRV200",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/trv200.png",
        "Brand": "Sunvic",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "TRV300",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/jkia1ctj.png",
        "Brand": "TA",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "TRV300",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/trv300.png",
        "Brand": "Sunvic",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TRV4 Chrome",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/trv4chrome.PNG",
        "Brand": "Drayton",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TRV4 Classic",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/trv4classic.jpg",
        "Brand": "Drayton",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TRV4 White",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/trv4white.jpg",
        "Brand": "Drayton",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "TRV500",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/trv500.jpg",
        "Brand": "Sunvic",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "TRV510",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/trv510.png",
        "Brand": "Sunvic",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TS",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/ts.jpg",
        "Brand": "Eberle",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TS - 5.11",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/ts-511.jpg",
        "Brand": "Eberle",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TS DCC",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/tsdcc.jpg",
        "Brand": "Eberle",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "Tala",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/jkl2mzcu.png",
        "Brand": "Orkli",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thera-100",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/thera-100.jpg",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thera-2",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/thera-2.jpg",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thera-20",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/thera-20.jpg",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thera-200",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/thera-200.jpg",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thera-3",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/thera-3.jpg",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thera-4 Classic",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/thera-4classic.jpg",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thera-4 Design",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/thera-4design.jpg",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thera-EL",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/thera-el.jpg",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thermo",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/thermo.jpg",
        "Brand": "Valvex",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thermostatic Head W5",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/thermostaticheadw5.jpg",
        "Brand": "SARCOMAP",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "Trade",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/trade.jpg",
        "Brand": "Siemens",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Uni L",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/unil.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "Uni LA",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/unila.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Uni LD",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/unild.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible_with_adapter_danfoss",
        "adapter": "M33x20",
        "name": "Uni LDV",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/unildv.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "Uni LDVL",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/unildvl.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Uni LH",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/unilh.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Uni LHB",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/unilhb.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "Uni LI",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/unili.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "Uni LK",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/unilk.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "Uni LM",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/unilm.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "Uni LO",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/unilo.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "Uni LR",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/unilr.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "Uni LV",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/unilv.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Uni SH",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/unish.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Uni XH",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/unixh.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Uni XHM",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/unixhm.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Heimeier VK",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/vk.jpg",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Heimeier VK old",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/vkold.jpg",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "VT117e - VTL120",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/vt117e-vtl120.PNG",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "VT15",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/vt15.PNG",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "VT200e",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/vt200e.PNG",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Vector",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/vector.jpg",
        "Brand": "Valvex",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Vindo CH",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/vindoch.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Vindo TH",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/vindoth.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Vinto RTD",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/vintortd.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Vinto TD",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/vintotd.jpg",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Virgo",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/virgo.jpg",
        "Brand": "Valvex",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "WESTHERM 5",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/westherm5.jpg",
        "Brand": "SARCOMAP",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "WK",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/wk.jpg",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "WK old",
        "imgname": "https://netatmostatic.blob.core.windows.net/static/images/check/valvesmodel/wkold.jpg",
        "Brand": "Heimeier",
        "field6": ""
    }
];

export const brands = [
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e97c075b400156bbb2a",
        "name": "ARCO",
        "linkname": "arco",
        "imgname": "Arco"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e98342e2d001461fe16",
        "name": "Alliance",
        "linkname": "alliance",
        "imgname": "Alliance"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e97413a7b001386755e",
        "name": "Altecnic",
        "linkname": "altecnic",
        "imgname": "Altecnic"
    },
    {
        "compatibility": "compatible",
        "adapter": null,
        "_id": "5f105e9ec075b400156bbb35",
        "name": "BRV",
        "linkname": "brv",
        "imgname": "BRV"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e97413a7b001386755d",
        "name": "BathEmpire",
        "linkname": "bath-empire",
        "imgname": "BathEmpire"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e97342e2d001461fe15",
        "name": "Blyss",
        "linkname": "blyss",
        "imgname": "Blyss"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e96342e2d001461fe14",
        "name": "Boss",
        "linkname": "Boss",
        "imgname": "Boss"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9e413a7b0013867566",
        "name": "Caleffi",
        "linkname": "caleffi",
        "imgname": "Caleffi"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e98413a7b001386755f",
        "name": "Danfoss",
        "linkname": "danfoss",
        "imgname": "Danfoss"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e96342e2d001461fe13",
        "name": "Drayton",
        "linkname": "drayton",
        "imgname": "Drayton"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e96413a7b001386755c",
        "name": "ECA",
        "linkname": "eca",
        "imgname": "ECA"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e95413a7b001386755a",
        "name": "EMMETI",
        "linkname": "emmeti",
        "imgname": "EMMETI"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e95413a7b0013867559",
        "name": "EQ-3",
        "linkname": "eq-3",
        "imgname": "EQ-3"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e94413a7b0013867558",
        "name": "EUROTRONIC",
        "linkname": "eurotronic",
        "imgname": "EUROTRONIC"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e96c075b400156bbb29",
        "name": "Eberle",
        "linkname": "eberle",
        "imgname": "Eberle"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e95413a7b001386755b",
        "name": "Elgato",
        "linkname": "elgato",
        "imgname": "Elgato"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e93342e2d001461fe11",
        "name": "FAR",
        "linkname": "far",
        "imgname": "FAR"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e92413a7b0013867557",
        "name": "GAMPPERARMATUREN",
        "linkname": "GAMPPERARMATUREN",
        "imgname": "GAMPPERARMATUREN"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e94342e2d001461fe12",
        "name": "GENEBRE",
        "linkname": "genebre",
        "imgname": "GENEBRE"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9e342e2d001461fe1b",
        "name": "Giacomini",
        "linkname": "giacomini",
        "imgname": "Giacomini"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9d342e2d001461fe1a",
        "name": "Heimeier",
        "linkname": "heimeier",
        "imgname": "Heimeier"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9dc075b400156bbb33",
        "name": "Herz",
        "linkname": "herz",
        "imgname": "Herz"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9d413a7b0013867565",
        "name": "HoneywellBraukmann",
        "linkname": "honeywell-braukmann",
        "imgname": "Honeywell"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e92c075b400156bbb23",
        "name": "IVAR",
        "linkname": "ivar",
        "imgname": "IVAR"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9dc075b400156bbb32",
        "name": "JAGA",
        "linkname": "jaga",
        "imgname": "Jaga"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e9c342e2d001461fe19",
        "name": "Landis&gyr",
        "linkname": "landis--gyr",
        "imgname": "Landis&gyr"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e92c075b400156bbb22",
        "name": "MMA",
        "linkname": "mma",
        "imgname": "MMA"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e9c413a7b0013867564",
        "name": "MNG",
        "linkname": "mng",
        "imgname": "MNG"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e93c075b400156bbb25",
        "name": "Myson",
        "linkname": "myson",
        "imgname": "Myson"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9c413a7b0013867563",
        "name": "Orkli",
        "linkname": "orkli",
        "imgname": "Orkli"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9cc075b400156bbb31",
        "name": "Oventrop",
        "linkname": "oventrop",
        "imgname": "Oventrop"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e91413a7b0013867556",
        "name": "Pegler",
        "linkname": "pegler",
        "imgname": "Pegler"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9ec075b400156bbb34",
        "name": "Pettinaroli",
        "linkname": "pettinaroli",
        "imgname": "Pettinaroli"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e91342e2d001461fe10",
        "name": "Pintossi",
        "linkname": "pintossi",
        "imgname": "Pintossi"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e9b413a7b0013867562",
        "name": "Polytronic",
        "linkname": "polytronic",
        "imgname": "Polytronic"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e9bc075b400156bbb30",
        "name": "Pont-à-Mousson",
        "linkname": "pont--mousson",
        "imgname": "Pont-à-Mousson"
    },
    {
        "compatibility": "compatible",
        "adapter": null,
        "_id": "5f105e9bc075b400156bbb2f",
        "name": "RBMrobsom",
        "linkname": "rbm--robsom",
        "imgname": "RBMrobsom"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e9ac075b400156bbb2e",
        "name": "Rossweiner",
        "linkname": "rossweiner",
        "imgname": "Rossweiner"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9ac075b400156bbb2d",
        "name": "SARCOMAP",
        "linkname": "sar-comap",
        "imgname": "SarComap"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e9a413a7b0013867561",
        "name": "Sam-Slovarm",
        "linkname": "sam---slovarm",
        "imgname": "Sam-Slovarm"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9ac075b400156bbb2c",
        "name": "Schlosser",
        "linkname": "schlsser",
        "imgname": "Schlosser"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e94c075b400156bbb26",
        "name": "Siemens",
        "linkname": "siemens",
        "imgname": "Siemens"
    },
    {
        "compatibility": "compatible_with_adapter_m28x1",
        "adapter": null,
        "_id": "5f105e94c075b400156bbb27",
        "name": "Sunvic",
        "linkname": "sunvic",
        "imgname": "Sunvic"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e91c075b400156bbb21",
        "name": "TA",
        "linkname": "ta",
        "imgname": "TA"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e93c075b400156bbb24",
        "name": "TADO",
        "linkname": "tado",
        "imgname": "Tado"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e99342e2d001461fe18",
        "name": "Tiemme",
        "linkname": "tiemme",
        "imgname": "Tiemme"
    },
    {
        "compatibility": "compatible_with_adapter_vaillant",
        "adapter": null,
        "_id": "5f105e95c075b400156bbb28",
        "name": "Vaillant",
        "linkname": "vaillant",
        "imgname": "Vaillant"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e99413a7b0013867560",
        "name": "ValfSanayii",
        "linkname": "valf-sanayii",
        "imgname": "ValfSanayii"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e99c075b400156bbb2b",
        "name": "Valvex",
        "linkname": "valvex",
        "imgname": "Valvex"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e98342e2d001461fe17",
        "name": "Watts",
        "linkname": "watts",
        "imgname": "Watts"
    }
];